module.exports = __webpack_public_path__ + "static/media/sandbox.6207fc1e.svg";